import React from 'react';

interface InveraIconProps {
  className?: string;
  size?: number | string;
}

/**
 * Invera Icon - Official double-chevron logo
 * Designed to work similarly to Lucide icons for consistency
 */
const InveraIcon: React.FC<InveraIconProps> = ({ className = "w-6 h-6", size }) => {
  // If size is provided, use it for width/height style
  const sizeStyle = size ? { width: size, height: size } : undefined;

  return (
    <svg
      className={className}
      style={sizeStyle}
      viewBox="0 0 258 198"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Official Invera Logo - Double Chevron X (traced from favicon) */}
      {/* Right Chevron (Gray) - Points left (rendered first, behind) */}
      <path
        d="M 258 0 L 159 99 L 258 198 L 198 198 L 99 99 L 198 0 Z"
        fill="#5A5A5A"
      />
      {/* Left Chevron (Red) - Points right (rendered last, on top) */}
      <path
        d="M 0 0 L 99 99 L 0 198 L 60 198 L 159 99 L 60 0 Z"
        fill="#E63946"
      />
    </svg>
  );
};

export default InveraIcon;
